import React from "react";
import "./button.css";

interface SvgIconButtonProps {
  Icon?: React.ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
  testId?: string;
}

const SvgIconButton: React.FC<SvgIconButtonProps> = ({ Icon, onClick, ariaLabel, testId }) => {
  return (
    <button
      type="button"
      className="btn-icon-primary counter-button"
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {Icon}
    </button>
  );
};

export default SvgIconButton;
